import { createFileRoute } from '@tanstack/react-router';
import { checkSecurityDomain } from '../../../utils/auth';

export const Route = createFileRoute('/team-insights/sessions/session/$sessionTitle')({
  beforeLoad: checkSecurityDomain({
    routeObject: 'analytics',
  }),
});
